import React, { useState } from "react";

import "./Message-List.css";
import Message from "./meesage";

// COMPONENTE DE IMAGEN
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";

function MessageList({ messages, tipo }) {
  const [imagenActiva, setImagenActiva] = useState("");

  const messageList = messages.map((message) => {
    const dd = message.tipoUsuario === tipo ? "you-message" : "other-message";
    const clase = "message-row " + dd;
    console.log(dd, tipo, message.tipoUsuario);
    return (
      <div key={message.instante.seconds}>
        <Message message={message} tipo={message.tipo} clase={clase} setImagenActiva={setImagenActiva} />
        {imagenActiva !== "" ? (
          <Lightbox showTitle={false} onClose={() => setImagenActiva("")} image={imagenActiva} title="Image Title"></Lightbox>
        ) : null}
      </div>
    );
  });
  return <div id="chat-message-list">{messageList}</div>;
}

export default MessageList;
